import axios from "axios";

export default {
  namespaced: true,
  state: {
    countries: [],
  },
  getters: {
    countries(state) {
      return state.countries;
    },
  },
  mutations: {
    SET_COUNTRIES(state, countries) {
      state.countries = countries;
    },
  },
  actions: {
    async get({ commit }) {
      let { data } = await axios.get("countries");
      commit("SET_COUNTRIES", data);
    },
  },
};
